var GradualFade = function({ text, spanLen, iterCount, ellipsis, opacityFactor }) {
	if (opacityFactor === undefined) {
		opacityFactor = 0.85;
	}
	return (
		<span className="gradualFade">
			{ fadeHelper(text, spanLen, iterCount, ellipsis, opacityFactor) }
		</span>
	);
};

function fadeHelper(text, spanLen, iterCount, ellipsis, opacityFactor) {
	if ((text.length == 0) || (iterCount == 0)) {
		if (ellipsis) {
			return "...";
		} else {
			return undefined;			
		}
	}

	var thisText = text.substring(0, spanLen);
	var nextText = text.substring(spanLen);

	return (
		<span style={{ opacity: opacityFactor }}>
			{ thisText }{ fadeHelper(nextText, spanLen, iterCount - 1, ellipsis, opacityFactor) }
		</span>
	)
}

GradualFade.propTypes = StrictPropTypes({
	text: PropTypes.string.isRequired,
	spanLen: PropTypes.number.isRequired,
	iterCount: PropTypes.number.isRequired,
	ellipsis: PropTypes.bool,
	opacityFactor: PropTypes.number
});

module.exports = GradualFade;


// WEBPACK FOOTER //
// ./modules/components/utility/GradualFade.js